import React from 'react';
import { NavLink, Route, RouteComponentProps } from 'react-router-dom';

import { Menu } from 'semantic-ui-react';
import { clienteApi, Resultados } from 'src/api';
import { Contexto } from 'src/contexto';
import { AsistenciaPrevia } from './Asistencia/AsistenciaPrevia';
import { IngresarAsistencia } from './Asistencia/IngresarAsistencia';
import Informacion from './Informacion';
import Puntajes from './Puntajes';

interface State {
    readonly detalleDelCurso?: Readonly<Resultados<'detallesDelCursoDeId'>>;
}

class DetalleDelCurso extends React.Component<RouteComponentProps<{ id: string }>, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;
    public readonly state: State = {};

    private readonly idCurso = Number(this.props.match.params.id);

    public render() {
        const rutaBase = this.props.match.url;

        const esProfesorOAdministradorDeAsistencias = this.context.usuarioActual.tieneAlgunaDeEstasFunciones(
            'administrador_asistencias',
            'profesor',
        );

        return (
            <>
                <Menu tabular>
                    <Menu.Item as={NavLink} exact to={rutaBase} content='Información' />
                    <Menu.Item as={NavLink} exact to={rutaBase + '/puntajes'} content='Puntajes' />
                    {esProfesorOAdministradorDeAsistencias && (
                        <Menu.Item
                            as={NavLink}
                            exact
                            to={rutaBase + '/asistencia/ingresar'}
                            content='Pasar asistencia'
                        />
                    )}

                    <Menu.Item
                        as={NavLink}
                        exact
                        to={rutaBase + '/asistencia/ingresada'}
                        content='Asistencias previas'
                    />
                </Menu>

                <Route
                    exact
                    path={rutaBase}
                    children={props =>
                        props.match && (
                            <Informacion
                                {...props}
                                idCurso={this.idCurso}
                                actualizarDetalle={this.obtenerDatos}
                            />
                        )
                    }
                />

                <Route
                    exact
                    path={rutaBase + '/puntajes'}
                    children={({ match }) => (
                        <Puntajes
                            ocultar={!match}
                            idCurso={this.idCurso}
                            detalleDelCurso={this.state.detalleDelCurso}
                            actualizarDetalle={this.obtenerDatos}
                        />
                    )}
                />

                {esProfesorOAdministradorDeAsistencias && (
                    <Route
                        exact
                        path={rutaBase + '/asistencia/ingresar'}
                        render={() => (
                            <IngresarAsistencia
                                detalleDelCurso={this.state.detalleDelCurso}
                                actualizarDetalle={this.obtenerDatos}
                            />
                        )}
                    />
                )}

                <Route
                    exact
                    path={rutaBase + '/asistencia/ingresada'}
                    render={() => (
                        <AsistenciaPrevia
                            detalleDelCurso={this.state.detalleDelCurso}
                            actualizarDetalle={this.obtenerDatos}
                        />
                    )}
                />
            </>
        );
    }

    private readonly obtenerDatos = async () => {
        const detalleDelCurso = await clienteApi.ejecutar('detallesDelCursoDeId', this.idCurso);

        this.setState({ detalleDelCurso });

        return detalleDelCurso;
    };
}

export default DetalleDelCurso;



// WEBPACK FOOTER //
// ./src/modulos/Horarios/DetalleDelCurso/index.tsx